import React from "react";
import { useDispatch } from 'react-redux';

import { Button } from "rhombus-react";

import { tellSentry } from 'utils/Rave';
import { openModal } from 'reducers/Modal';
import { MODAL_TYPES } from 'utils/constants';

import "./VersionImportErrorGrowl.css";

export default function VersionImportErrorGrowl({ filename, error }){
	const dispatch = useDispatch();

	/* this is copy-pasted from 'widgets/messages/VersionsImportSocketError.js' */
	function viewErrors() {
		let parsedErrors;
		// Putting this in a try block in case the error comes back in an unparseable way
		try {
			parsedErrors = JSON.parse(error);
			if (!Array.isArray(parsedErrors)) {
				throw new Error();
			}
		} catch (e) {
			parsedErrors = ["An unknown error has occurred"];
			tellSentry(`Expected error to be of type array. Received ${typeof error}`);
		}
		dispatch(
			openModal(MODAL_TYPES.IMPORT_VERSIONS_ERROR, { filename, errors: parsedErrors })
		);
	}

	return (
		<div className="version-import-growl-body">
			<div>{filename}</div>
			<div>
				<Button theme="red" size="small" onClick={viewErrors}>
					View Errors
				</Button>
			</div>
		</div>
	);
}
